export default [
  {
    id: 'section1',
    staff: [
      {
        image: '/staff/Bob-Kalas@2x.jpg',
        name: 'Bob Kalas',
        title: 'Owner/Funeral Director & Crematory Operator',
      },
      {
        image: '/staff/George-Kalas@2x.jpg',
        name: 'George Kalas',
        title: 'Owner/Funeral Director & Crematory Operator',
      },
    ],
  },
  {
    id: 'section2',
    staff: [
      {
        image: '/staff/Juliette-Ale@2x.jpg',
        name: 'Juliette Ale',
        title: 'Funeral Director & Crematory Operator',
      },
      {
        image: '/staff/Valerie-Armstrong@2x.jpg',
        name: 'Valerie Armstrong',
        title: 'Funeral Director',
      },
      {
        image: '/staff/Karen-Hicks.jpg',
        name: 'Karen Hicks',
        title: 'Funeral Director',
      },
      {
        image: '/staff/Zach-Kalas@2x.jpg',
        name: 'Zach Kalas',
        title: 'Funeral Director & Crematory Operator',
      },
      {
        image: '/staff/Todd-Liller@2x.jpg',
        name: 'Todd Liller',
        title: 'Funeral Director & Crematory Operator',
      },
      {
        image: '/staff/Scottie-Nuthall@2x.jpg',
        name: 'Scotty Nuthall',
        title: 'Funeral Director & Crematory Operator',
      },
      {
        image: '/staff/Ashley-Whiteley.jpg',
        name: 'Ashley Whiteley',
        title: 'Funeral Director',
      },
      {
        image: '/staff/Brittaney-Wood@2x.jpg',
        name: 'Brittaney Wood',
        title: 'Funeral Director',
      },
      {
        image: '/staff/Lori-Wroten@2x.jpg',
        name: 'Lori Wroten',
        title: 'Funeral Director & Crematory Operator',
      },
      {
        image: '/staff/Placeholder-Woman.jpg',
        name: 'Madison Staples',
        title: 'Licensed Apprentice',
      },
    ],
  },
  {
    id: 'section3',
    staff: [
      {
        image: '/staff/Paul-Dennis.jpg',
        name: 'Paul Dennis',
        title: 'Funeral Assistant',
      },
      {
        image: '/staff/Matt-Garofalo@2x.jpg',
        name: 'Matt Garofalo',
        title: 'Funeral Assistant',
      },
      {
        image: '/staff/Gary-Gertz.jpg',
        name: 'Gary Gertz',
        title: 'Funeral Assistant',
      },
      {
        image: '/staff/Raymond-Luby@2x.jpg',
        name: 'Ray Luby',
        title: 'Funeral Assistant',
      },
      {
        image: '/staff/Pat-MacFarlane@2x.jpg',
        name: 'Pat MacFarlane',
        title: 'Funeral Assistant',
      },
      {
        image: '/staff/Daionna-Maynard.jpg',
        name: 'Daionna Maynard',
        title: 'Funeral Assistant',
      },
      {
        image: '/staff/Doris-Patterson@2x.jpg',
        name: 'Doris Patterson',
        title: 'Funeral Assistant',
      },
      {
        image: '/staff/Kim-Rosekrans@2x.jpg',
        name: 'Kim Rosekrans',
        title: 'Funeral Assistant',
      },
      {
        image: '/staff/Michael-Crutchfield.jpg',
        name: 'Michael Crutchfield',
        title: 'Funeral Assistant',
      },
    ],
  },
  {
    id: 'section4',
    staff: [
      {
        image: '/staff/Don-Rakoskie@2x.jpg',
        name: 'Don Rakoskie',
        title: 'Business Manager',
      },
    ],
  },
]
